import WechatJSSDK from "wechat-jssdk/dist/client.umd";
import { getWechatConfig, wechatAuth } from "@api/public";
import { parseQuery } from "@utils";
import cookie from "@utils/store/cookie";
import store from "@/store";
// import { VUE_APP_API_URL } from "@utils/index";

const STATE_KEY = "wx_authorize_state";
const WX_AUTH = "wx_auth";
const BACK_URL = "login_back_url";
let instance;
let wechatObj;
let instancePromise;

export default function wechat() {
  // 缓存初始化 Promise 而非实例，避免并发调用在 instance 就绪前各自请求一次签名
  if (!instancePromise) {
    instancePromise = getWechatConfig()
      .then((res) => {
        const conf = {
          appId: res.result.appId,
          nonceStr: res.result.nonceStr,
          signature: res.result.signature,
          timestamp: res.result.timestamp,
        };
        const _wx = WechatJSSDK(conf);

        wechatObj = _wx;
        return _wx.initialize().then(() => {
          instance = _wx.wx;
          instance.initConfig = conf;
          return instance;
        });
      })
      .catch((err) => {
        // 初始化失败后清空缓存，允许下次重新初始化
        instancePromise = null;
        console.log(err);
        throw err;
      });
  }
  return instancePromise;
}

export function clearAuthStatus() {
  cookie.remove(WX_AUTH);
  cookie.remove(STATE_KEY);
}

// 校验回调携带的 state 是否为本次授权发起时写入的值
export function checkAuthState(state) {
  const saved = cookie.get(STATE_KEY);
  return !!saved && !!state && saved === state;
}

export function wxLogin(data) {
  console.info("wxLogin:", data);
  this.$store.commit("LOGIN", data);
  cookie.set(WX_AUTH, data.token, data.expire);
  cookie.remove(STATE_KEY);
  cookie.remove("loginType");
}

export function oAuth() {
  // if (cookie.has(WX_AUTH) && store.state.app.token) return;
  if (store.state.app.token) return;
  const { code } = parseQuery();
  if (!code) return toAuth();
}

export function auth(code) {
  return new Promise((resolve, reject) => {
    wechatAuth(code)
      .then((res) => {
        let data = res.result;
        console.info("wechatAuth:", res);
        store.commit("LOGIN", data);
        cookie.set(WX_AUTH, data.token, data.expire);
        cookie.remove(STATE_KEY);
        resolve();
      })
      .catch(reject);
  });
}

let authorizing = false;

export function toAuth() {
  // 路由守卫与 main.js 可能在同一次加载里同时走到这里，
  // 授权跳转进行中直接忽略，避免发起两轮 OAuth 产生两个 code
  if (authorizing) return;
  authorizing = true;
  wechat()
    .then((wx) => {
      location.href = getAuthUrl(wx.initConfig.appId);
      // 跳转因故被拦截时允许重新发起授权
      setTimeout(() => (authorizing = false), 3000);
    })
    .catch((err) => {
      console.info("错了", err);
      authorizing = false;
    });
}

function getAuthUrl(appId) {
  let redirect_uri = encodeURIComponent(
    `${location.origin}/auth/` +
      encodeURIComponent(
        encodeURIComponent(
          cookie.has(BACK_URL)
            ? cookie.get(BACK_URL)
            : location.pathname + location.search
        )
      )
  );

  cookie.remove(BACK_URL);
  const state = ("" + Math.random()).split(".")[1] + "authorizestate";
  // cookie 存原值，供回调时与 query.state 比对
  cookie.set(STATE_KEY, state);
  // return `${VUE_APP_API_URL }/wechat/mp/hook/toGetInfo?BackURL=${location.origin}`
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${encodeURIComponent(
    state
  )}#wechat_redirect`;
}

function toPromise(fn, config = {}) {
  return new Promise((resolve, reject) => {
    fn({
      ...config,
      success(res) {
        resolve(res);
      },
      fail(err) {
        reject(err);
      },
      complete(err) {
        reject(err);
      },
      cancel(err) {
        reject(err);
      },
    });
  });
}

export function pay(config) {
  // 启动不再初始化 JSSDK，调用前先确保 wechat 初始化完成
  return wechat().then(() => toPromise(instance.chooseWXPay, config));
}

export function openAddress() {
  return new Promise((resolve, reject) => {
    wechatEvevt("openAddress", {})
      .then((res) => {
        resolve(res);
      })
      .catch((res) => {
        if (res.is_ready) {
          res.wx.openAddress({
            fail(res) {
              reject(res);
            },
            success(res) {
              resolve(res);
            },
          });
        } else {
          reject(res);
        }
      });
  });
}

export function openShareAll(config) {
  config || {};
  config.type = config.type == undefined ? "link" : config.type;
  return new Promise((resolve) => {
    wechat().then(() => {
      getWechatConfig().then((res) => {
        wechatObj.signSignature({
          nonceStr: res.result.nonceStr,
          signature: res.result.signature,
          timestamp: res.result.timestamp,
        });
        instance = wechatObj.getOriginalWx();
        instance.ready(() => {
          // instance.updateAppMessageShareData(config);
          // instance.updateTimelineShareData(config);
          openShareAppMessage(config);
          openShareTimeline(config);
          resolve();
        });
      });
    });
  });
}

/**
 * 分享给朋友接口
 * @param config
 */
export function openShareAppMessage(config) {
  instance.updateAppMessageShareData(config);
  instance.onMenuShareAppMessage && instance.onMenuShareAppMessage(config);
}

/**
 * 分享到朋友圈
 * @param config
 */
export function openShareTimeline(config) {
  instance.updateTimelineShareData(config);
  instance.onMenuShareTimeline && instance.onMenuShareTimeline(config);
}

/**
 * 公众号事件
 * @param name 事件名
 * @param config 配置
 * @returns {Promise<unknown>}
 */
export function wechatEvevt(name, config) {
  return new Promise((resolve, reject) => {
    let wx;
    let configDefault = {
      fail(res) {
        console.log(res);
        if (wx) return reject({ is_ready: true, wx: wx });
        getWechatConfig().then((res) => {
          wechatObj.signSignature({
            nnonceStr: res.result.nonceStr,
            signature: res.result.signature,
            timestamp: res.result.timestamp,
          });
          wx = wechatObj.getOriginalWx();
          reject({ is_ready: true, wx: wx });
        });
      },
      success(res) {
        resolve(res);
      },
    };
    Object.assign(configDefault, config);
    if (typeof instance !== "undefined") {
      instance.ready(() => {
        if (typeof name === "object") {
          name.forEach((item) => {
            instance[item] && instance[item](configDefault);
          });
        } else instance[name] && instance[name](configDefault);
      });
    } else {
      getWechatConfig().then((res) => {
        const conf = {
          appId: res.result.appId,
          nonceStr: res.result.nonceStr,
          signature: res.result.signature,
          timestamp: res.result.timestamp,
        };
        const _wx = WechatJSSDK(conf);
        _wx.initialize().then(() => {
          wechatObj = _wx;
          instance = _wx.getOriginalWx();
          instance.ready(() => {
            if (typeof name === "object") {
              name.forEach((item) => {
                instance[item] && instance[item](configDefault);
              });
            } else instance[name] && instance[name](configDefault);
          });
        });
      });
    }
  });
}

export function ready() {
  return new Promise((resolve) => {
    if (typeof instance !== "undefined") {
      instance.ready(() => {
        resolve(instance);
      });
    } else {
      getWechatConfig().then((res) => {
        const jsApiList = [
          "checkJsApi",
          "updateAppMessageShareData",
          "updateTimelineShareData",
          "onMenuShareAppMessage",
          "onMenuShareTimeline",
        ];
        const conf = {
          appId: res.result.appId,
          nonceStr: res.result.nonceStr,
          signature: res.result.signature,
          timestamp: res.result.timestamp,
          jsApiList,
        };
        const _wx = WechatJSSDK(conf);
        _wx.initialize().then(() => {
          wechatObj = _wx;
          instance = _wx.wx;
          instance.ready(() => {
            resolve(instance);
          });
        });
      });
    }
  });
}
